import { Component, OnInit , Input, ViewChild, TemplateRef, AfterViewInit} from '@angular/core';
import { NgbModal, ModalDismissReasons } from '@ng-bootstrap/ng-bootstrap'; 
import { ActivatedRoute, Router } from '@angular/router';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
// import { SelectStoreComponent } from '../select-store/select-store.component';
import { MultipleSelectItemComponent } from '../multiple-select-item/multiple-select-item.component';
import { DataService } from "../../services/data.service";
import { APIService } from '../../api.service';
import { CommonService } from '../../services/common.service';
import { NgxSpinnerService } from 'ngx-spinner';
import { map, startWith } from 'rxjs/operators';
import { stubFalse } from 'lodash';
import { BatchSelectionComponent } from '../batch-selection/batch-selection.component';



@Component({
  selector: 'app-transaction-production',
  templateUrl: './transaction-production.component.html',
  styleUrls: ['./transaction-production.component.scss']
})

export class TransactionProductionComponent implements OnInit, AfterViewInit {

  modalReference: any;
  id: number = 0;
  //#region "Declaration"
  @Input() Data: any;
  @Input() mdlRef: any;
  frmStore = {
    id: '0',
    name: ''
  }
  allStoreCnt: number = 0;
  @Input() isFromInvList: boolean = false;
  @Input() StoreID: number = 0;
  @Input() AllOption: number = 1; 
  isWeb: boolean = true;
  issueQty: any;
  mtlQty: any;
  xnCode: any;
  jarvisData: any = [];
  MTbl: any = [];
  firstTime: number = 1;
  getAllItems: any = [];
  bomData : any = [];
  isShowPrevNo: boolean = false;
  prevXnCode: string = '';
  storeName: string = '';

  search = {term: ''};
  Cfg_AgnCfg: any = [];
  lastXNNos: any = [];
  jobDetails: any = [];
  generationList:any = [];
  isFromPrdJob: boolean = false;
  isGenEdit: boolean = false;
  isShowBOM: boolean = false;
  items: any = [];
  selStoreItems : any = [];
  prdItems : any = [];
  tempBOMData : any = [];
  storeDataList : any = [];
  store = {
    id: 0,
    name: ''
  } 
  batchCnt: any = 0;
  batchMode: any = '';
  batchList: any = [];
  stores: any = [];
  @ViewChild('selection') storeSelRef!: TemplateRef<any>;
  

  constructor(private modalService: NgbModal, private _Activatedroute: ActivatedRoute, public activeModal: NgbActiveModal, private dataSer: DataService, private apiService: APIService, private router: Router, private commonService: CommonService, private loadingPnl: NgxSpinnerService) {
   }
  ngAfterViewInit(): void {
    this.selectStore(this.storeSelRef);
  }
  
  ngOnInit(): void {
    var jarvis = this.apiService.getCookie("Jarvis");
    if (jarvis) {
      this.jarvisData = JSON.parse(jarvis);
    } 

    this.isWeb = this.apiService.apiCheckWeb();

    var tblM = this.apiService.getCookie("M");
    if(tblM) {
      this.MTbl = JSON.parse(tblM);
    }

    this.apiService.getIDB('erp_inv', (erp_inv: any) => {
      if (erp_inv && erp_inv.length > 0) {
        this.getAllItems = erp_inv;
      }
    });
    let tmpERP_Cfg = this.apiService.getCookie("ERP_Cfg");
    if(tmpERP_Cfg){
      this.storeDataList =  JSON.parse(tmpERP_Cfg);
      if(this.storeDataList[0].Stores){
        this.storeDataList = JSON.parse(this.storeDataList[0].Stores)
        this.allStoreCnt = this.storeDataList.length;
        // if(this.storeDataList.length == 1){
        //   this.storeName = this.storeDataList[0].sNm;
        //   this.openItemSelect(this.id);
        // }
        // else{
        //   this.storeDataList = this.storeDataList;
        //   this.allStoreCnt = this.storeDataList.length;
        // }
        
      }
    }

    
    //Get Store
    this.dataSer.store.subscribe((a: any) => {
      this.frmStore.id = a.id ? a.id : '0';
      this.frmStore.name = a.name;
    });
    
    // this.tempBOMData = this.bomData;
    this.dataSer.items.subscribe((value :any) => {
      let selectItem = this.apiService.getCookie("selectItem");
      if(selectItem == 'isPrd'){
        this.items = [];
      }
      
      value.forEach((a: any) => {
        // this.batchCnt = 0;
        if(a.BatchType != "undefined" && a.BatchType == 1 || a.BatchType == 2) {
          a.hasBatches = true;
          this.batchCnt = this.batchCnt + 1
        }
        else {
          a.hasBatches = false;
        }
        if(a.Batches != "undefined" && a.Batches && a.Batches.length > 0 ){
          let batchData   = JSON.parse(a.Batches);
          // this.batchList = [];	
          this.batchList = batchData;
        }
        let selItems = this.getAllItems.filter((x: any) => x.ItemID == a.ItemID);
        if(selectItem == "isPrd")
        {
          this.items.push({
            itemID: a.ItemID,
            doneQty: Number(0).toFixed(a.SKUPrecision),
            mtlQty: Number(0).toFixed(a.SKUPrecision),
            sku: a.SKU,
            strQty: Number(a.StoreQty).toFixed(a.SKUPrecision),
            prcsn: a.SKUPrecision,
            issueQty:Number(0).toFixed(a.SKUPrecision),
            itemName: a.ItemName,
            defStockRate: a.DefStockRate,
            isBom: a.Bom,
            stkQty: selItems.length > 0 ? Number(selItems[0].CurrQty).toFixed(selItems[0].SKUPrecision) : 0,
            hasBatches: a.hasBatches ? a.hasBatches : false,
            Batches : this.batchList ? this.batchList : [],
            BatchType : a.BatchType,
          }) 
         // this.apiService.setCookie("selItems", "isFromPrd");
         this.setPrdBatchCoockie();
         
        }
        else if(selectItem == "isMtrl"){
          let selStrItm = this.selStoreItems.filter((x: any) => x.ItemID == a.ItemID);
          let selBomItem = this.bomData.filter((x: any) => x.ItemID == a.ItemID);
          if(selBomItem.length > 0){
            this.tempBOMData.push({
              ItemID: selBomItem[0].ItemID,
              bomItemName: selBomItem[0].bomItemName ,
              mtlQty: Number(selBomItem[0].mtlQty).toFixed(selBomItem[0].prcsn),
              unit: selBomItem[0].Unt ? selBomItem[0].Unt : selBomItem[0].unit,
              prcsn: selBomItem[0].prcsn,
              storeItemQty: Number(selBomItem[0].storeItemQty).toFixed(selBomItem[0].prcsn),
              stkQty: Number(selBomItem[0].stkQty).toFixed(selBomItem[0].prcsn),
              hasBatches: a.hasBatches ? a.hasBatches : false,
              Batches : this.batchList ? this.batchList : [],
              BatchType : a.BatchType,
            });
          }
          else{
            this.tempBOMData.push({
              ItemID: a.ItemID,
              bomItemName: a.ItemName,
              mtlQty: Number(0).toFixed(a.SKUPrecision),
              unit: a.SKU,
              prcsn: a.SKUPrecision,
              storeItemQty:  selStrItm.length > 0 ?  Number(selStrItm[0].StoreItemQty).toFixed(selStrItm[0].SKUPrecision) :  Number(0).toFixed(a.SKUPrecision),
              stkQty: selItems.length > 0 ? Number(selItems[0].CurrQty).toFixed(selItems[0].SKUPrecision) : 0,
              hasBatches: a.hasBatches ? a.hasBatches : false,
              Batches : this.batchList ? this.batchList : [],
              BatchType : a.BatchType,
            });
          }
      }
      });
      if(this.tempBOMData.length > 0){
        this.bomData = [];
        this.bomData = this.tempBOMData;
        const bomArr = this.bomData.filter((obj:any, index:any, self:any) =>
          index === self.findIndex((t:any) => (
            t.ItemID === obj.ItemID 
          ))
        );
         this.bomData = bomArr;
      }
      
    });

     // Get Batches Data for perticular Item
     this.dataSer.batches.subscribe((value: any) => {
      if(value) {
        let fromMtrl = this.apiService.getCookie("selItems");
        if(fromMtrl == "isFromPrd"){
          this.items.forEach((element: any) => {
            if (value.itemID == element.itemID) {
              element.Batches = value.batchList;
              element.sumBatchesQty = value.sumBatchesQty;
              element.oldBatchList = value.oldBatchList;
            }
          });
        }

        if(fromMtrl == "isFromMtrl")
        {
          this.bomData.forEach((element: any) => {
            if (value.itemID == element.ItemID) {
              element.Batches = value.batchList;
              element.sumBatchesQty = value.sumBatchesQty;
              element.oldBatchList = value.oldBatchList;
            }
          });
        }
      }
    });

    var tmpCfg_AgnCfg = this.apiService.getCookie("Cfg_AgnCfg");
    
    // Logic moved out of getIDB
    this.id = this._Activatedroute.snapshot.params['id'];
    
    if (tmpCfg_AgnCfg) {
      this.Cfg_AgnCfg = JSON.parse(tmpCfg_AgnCfg);
      if (this.Cfg_AgnCfg[0].LastXnNos) {
        this.lastXNNos = JSON.parse(this.Cfg_AgnCfg[0].LastXnNos);
        let tmpType = 'XN-' + 10;
        this.lastXNNos = this.lastXNNos.filter((a: any) => a.XnTyp == tmpType);
      }
    }

    if (this.lastXNNos.length > 0) {
      let tmpLastXnNo = this.lastXNNos[0].LastNo;
      if (tmpLastXnNo) {
        if (isNaN(tmpLastXnNo)) {
          this.isShowPrevNo = true;
          this.prevXnCode = tmpLastXnNo;
        } else {
          this.isShowPrevNo = false;
          this.xnCode = Number(tmpLastXnNo) + 1;
        }
      }
    } else {
      this.xnCode = 1;
    }
  }

  //select product item
  openItemSelect(content: any) {
    this.modalReference = this.modalService.open(MultipleSelectItemComponent, { windowClass : "itemSelectionModalClass", backdrop: 'static', keyboard: false});
    this.modalReference.componentInstance.typeID = this.id;
    this.modalReference.componentInstance.it = this.items.map((a: any) => a.itemID);
    this.modalReference.componentInstance.st = this.frmStore.id;
    this.modalReference.componentInstance.stc = 0;
    this.modalReference.componentInstance.isMade = 1;
    this.modalReference.componentInstance.mdlRef = this.modalReference;
    //this.getItems();
    this.isGenEdit = true;
    this.setPrdBatchCoockie();
   // this.isShowBOM = false;
    this.apiService.setCookie("selectItem", "isPrd");
    this.batchList = [];
  }

  //select material item
  openMtlSelect(content: any) {
    this.modalReference = this.modalService.open(MultipleSelectItemComponent, { windowClass : "itemSelectionModalClass", backdrop: 'static', keyboard: false});
    this.modalReference.componentInstance.typeID = this.id;
    this.modalReference.componentInstance.it = this.bomData.map((a: any) => a.ItemID);
    this.modalReference.componentInstance.st = this.frmStore.id;
    this.modalReference.componentInstance.stc = 0;
    this.modalReference.componentInstance.ft = 0;
    this.modalReference.componentInstance.mdlRef = this.modalReference;
    this.isGenEdit = false; 
    this.setMtlBatchCoockie();
    //this.getItems();
    this.apiService.setCookie("selectItem", "isMtrl");
    this.tempBOMData = [];
    this.batchList = [];
  }

  openBatchSelectionMdl(content: any) {
   let fromMtrl = this.apiService.getCookie("selItems");
   if(fromMtrl == "isFromMtrl"){
      this.batchMode = "Out";
    }
    else if(fromMtrl == "isFromPrd") {
      this.batchMode = "In";
    }
    this.modalReference = this.modalService.open(BatchSelectionComponent, { windowClass : "BatchSelection", backdrop: 'static', keyboard: false});
    this.modalReference.componentInstance.mdlRef = this.modalReference;
    this.modalReference.componentInstance.modeType = this.batchMode;
    this.modalReference.componentInstance.isXn = true;
    this.modalReference.componentInstance.xnID =  10;
    
    if(fromMtrl == "isFromPrd"){
      this.modalReference.componentInstance.itemID = content.itemID;
      this.items.forEach((element: any) => {
        if (content.itemID == element.itemID) {
          //this.batchList = [];
          this.batchList = element.Batches
          this.modalReference.componentInstance.batchesList = this.batchList;
        }
      });
    }
    if(fromMtrl == "isFromMtrl")
    {
      this.modalReference.componentInstance.itemID = content.ItemID;
      this.bomData.forEach((element: any) => {
        if (content.ItemID == element.ItemID) {
          this.batchList = element.Batches
          this.modalReference.componentInstance.batchesList = this.batchList;
        }
      });
    }
   
    this.dataSer.updateByProduct(content);
  }

  // selectStore() {
  // this.items = [];
  // this.bomData = [];
  // this.modalReference = this.modalService.open(SelectStoreComponent, { backdrop: 'static', keyboard: false });
  //  this.modalReference.componentInstance.AllOption = 0; 
  //  this.modalReference.componentInstance.StoreID = this.frmStore.id;
  //  this.modalReference.componentInstance.mdlRef = this.modalReference; 
  //  this.modalReference.result.then((result: any) => {
  //     if (result.length > 0) {
  //       this.frmStore.id = result[0].StrID;
  //       this.frmStore.name = result[0].sNm;
  //       this.openItemSelect(this.id);
  //       this.getItems();
  //     }
  //   });
   
  // }

  
  //select store
  selectStore(sel: any) {
    this.modalReference = this.modalService.open(sel, {windowClass: 'xnPrdnStoreMdl', backdrop: 'static', keyboard: false});
  }

  //store selection
  save() {
    let selStore = this.storeDataList.filter((a: any) => a.StrID == this.frmStore.id);
    if (selStore.length == 0) {
      if(this.frmStore.id == '0') {
        this.apiService.successAlert('Please select a store.');
        return;
      }
      else {
        selStore = [{ StrID: 0, sNm: "All Stores" }];
        this.modalReference.close();
        this.isGenEdit = false;
      }
    }
    else {
      this.closeModal();
      //this.modalReference.close();
      this.openItemSelect(this.id);
      this.getItems();
      
    }
  }

  //close items model
  closeModal() {
    this.modalReference.close();
    this.isGenEdit = true;
    //this.isShowBOM = false;
  }

  //calculate bom 
  proposeQty() {
    this.generationList = [];
    this.issueQty = 0;
    for (let i = 0; i < this.items.length; i++) {
      if( this.items[i].issueQty == 0 ){
        this.apiService.successAlert("Please enter a quantity.");
        return;
      }

      // let btchQtyCheck = this.items.filter((b: any) => b.transferQty != b.sumBatchesQty && b.hasBatches);	
      if((this.items[i].BatchType == 1 || this.items[i].BatchType == 2) && this.items[i].issueQty != this.items[i].sumBatchesQty ) {	
        this.apiService.successAlert("Please ensure that the total quantity of batches matches the total transaction quantity of " + this.items[i].itemName + ".");	
          return;	
      }

      if(this.items[i].issueQty != ''){
        this.issueQty = Number(this.items[i].issueQty);
        this.generationList.push({
          iotemID:  this.items[i].itemID,
          mtlQty:  this.issueQty,
          doneQty: 0,
          xnIDs: '',
          description: '',
        })
      }
    }

    this.isShowBOM = true;
    this.isGenEdit = false;
    if(this.generationList.length > 0){
      this.getBOMItemsData();
    }
    else{
      this.apiService.successAlert("Please enter a quantity.");
      return;
    }
         
  }
  
 //get items sotre wise -for store qty 
  getItems(){
    let data = [{
      StatusID: 1,
      StoreID: this.frmStore.id
    }];
    let myParams = [{ 
      myUserID: this.jarvisData[0].UserID,
      myToken: this.jarvisData[0].WebToken,
      forAgencyID: this.jarvisData[0].AgencyIDs,
      myAgencyIDs: this.jarvisData[0].AgencyIDs,
      ForERPAgencyID: this.MTbl[0].ERPAgencyID,
      myLastSyncDT: null,
      isWeb: true,
      actionType: 'get',
      moduleID: 5,
      data: JSON.stringify(data)
    }];
    this.loadingPnl.show();
    this.apiService.getData(myParams, this.successItemResp.bind(this), this.failureResp.bind(this));
  }

  //successItemResp - success  get handler
  successItemResp(res: any) {
    this.loadingPnl.hide();
    if (res.error) {
    }
    else {
      if (res) {
        var reponseData = JSON.parse(res.updatePackage);
        if (reponseData) {
          let tempdata= reponseData;
            this.selStoreItems = tempdata.Table1;
            this.selStoreItems.forEach((element: any) => {
              element.Bom = false;
              if(element.StoreBatches) {
                element.StoreBatches = JSON.parse(element.StoreBatches);
                if(element.StoreBatches.length > 0) {
                  let tmpQty = element.StoreBatches.filter((a: any) => { return a.SID == this.frmStore.id });
                  if(tmpQty.length > 0){
                    element.StoreItemQty = tmpQty[0].Q;
                  } else {
                    element.StoreItemQty = 0;
                  }
                }
              }
              else{
                element.StoreBatches = [];
              }
            });
        }
      }
    }
  }

  //getBOMItemsData - get bom details
  getBOMItemsData() {
    if (this.items.length == 0) {
      alert('Please select a product.');
      return;
    }
    else {
      var tempData = [{
        'Generation': JSON.stringify(this.generationList),
      }]

      let MyLastSyncDT = localStorage.getItem("MyLastSyncDT")
      let myParams = [{
        myUserID: this.jarvisData[0].UserID,
        myToken: this.jarvisData[0].WebToken,
        forAgencyID: this.jarvisData[0].AgencyIDs,
        myAgencyIDs: this.jarvisData[0].AgencyIDs,
        myLastSyncDT: MyLastSyncDT,
        isWeb: true,
        ForERPAgencyID: this.MTbl[0].ERPAgencyID,
        actionType: 'getQckInvXn',
        moduleID: 11,
        data: JSON.stringify(tempData)
      }];
      this.loadingPnl.show();
      this.apiService.getData(myParams, this.successPrdDetails.bind(this), this.failureResp.bind(this));
    }
  }

  //success prddetails
  successPrdDetails(res: any) {
    this.loadingPnl.hide();
    if (res.error) {
    }
    else {
      if (res) {
        var reponseData = JSON.parse(res.updatePackage);
        if (reponseData) {
          this.bomData = reponseData.Table1;
          this.bomData .forEach((a: any) => {
            let selstrItems = this.selStoreItems.filter((x: any) => x.ItemID == a.ItemID);
            var selItems = [];
            selItems = this.getAllItems.filter((x: any) => x.ItemID == a.ItemID);
            if(selItems.length > 0){
              a.bomItemName = selItems[0].ItemName;
              a.unit =  a.Unt;
              a.prcsn = selItems[0].SKUPrecision;
              a.stkQty = selItems[0].CurrQty;
              a.mtlQty = Number(a.MtlQty).toFixed(selItems[0].SKUPrecision);
              a.storeItemQty = selstrItems.length > 0 ? Number(selstrItems[0].StoreItemQty).toFixed(selstrItems[0].SKUPrecision) : 0;
              a.hasBatches = a.hasBatches,
              a.Batches = a.Batches ? a.Batches : [],
              a.BatchType = selItems[0].BatchType
            }
           // this.batchCnt = 0;
            if(a.BatchType != "undefined" && a.BatchType == 1 || a.BatchType == 2) {
              a.hasBatches = true;
              this.batchCnt = this.batchCnt + 1
            }
            else {
              a.hasBatches = false;
            }
            // if(a.Batches && a.Batches.length > 0 ){
            //   let batchData   = JSON.parse(a.Batches);
            //   // this.batchList = [];	
            //   this.batchList = batchData;
            // }

            this.setMtlBatchCoockie();
           // this.apiService.setCookie("selItems", "isFromMtrl");
          });
          // this.bomData = this.bomData.sort((a: any, b: any) => a.bomItemName.localeCompare(b.bomItemName));
        }
      }
    }
  }

  //delete items
  deleteItem(index: number) {
    this.items.splice(index, 1);
    if(this.items.length == 0){
      this.isGenEdit = false;
      this.bomData = [];
    }  
     
  }

  //delete BOM 
  deleteBOMItems(index: number) {
    this.bomData.splice(index, 1);
    if(this.items.length == 0){
      this.isGenEdit = false;
    }  
  }
  
  //redirect stock
  backBtn() {
    this.router.navigate(['Stock']);
  }
  
  //save producton entry
  fn_savePrdEnty() {
    let chkStock = this.bomData.filter((p: any) => (Number(p.mtlQty) > Number(p.storeItemQty)));
    if(chkStock.length > 0) {
      this.apiService.successAlert('Used quantity must be less than or equal to the store quantity.');
      return;
    }
    
    let chkStockQTY = this.bomData.filter((p: any) => Number(p.mtlQty) == 0);
    if(chkStockQTY.length > 0) {
      this.apiService.successAlert('Used quantity must be non-zero.');
      return;
    }

    let btchQtyCheck = this.bomData.filter((b: any) => b.mtlQty != b.sumBatchesQty && b.hasBatches);	
    if(btchQtyCheck.length > 0) {	
      this.apiService.successAlert("Please ensure that the total quantity of batches matches the total transaction quantity of " + btchQtyCheck[0].bomItemName + ".");	
        return;	
    }
    // if(e.mtlQty != e.sumBatchesQty ) {	
    //   this.apiService.successAlert("Kindly ensure that the total quantity of batches matches the total quantity being transferred for " + e.itemName + ".");	
    //     return;	
    // }


    let inItems: any = [];
    let outItems: any = [];
    let srNo: number = 1;
    // let tmpSrNo = srNo++
    this.items.forEach((e: any) => {
      if(e.Batches && e.Batches != undefined) {
        e.Batches = e.Batches.filter((x: any) => Number(x.Q) != 0);
      }
      let tmpSrNo = srNo++
      inItems.push({
          SrNo: tmpSrNo,
          ItemID: e.itemID,
          InQty:  parseFloat(e.issueQty) + "",
          OutQty: "0",
          Unit: e.sku,
          Rate: 0,
          Notes: '',
          BatchID: 0,
          BatchNo: 0,
          Batches: e.Batches ? JSON.stringify(e.Batches) : '[]'
        })
    });

    this.bomData.forEach((e: any) => {
      
      if(e.Batches && e.Batches != undefined) {
        e.Batches = e.Batches.filter((x: any) => Number(x.Q) != 0);
      }
      
      let tmpSrNo = srNo++
      if(e.mtlQty) {
          outItems.push({
            SrNo: tmpSrNo,
            ItemID: e.ItemID,
            InQty: "0",
            OutQty: parseFloat(e.mtlQty) + "", 
            Unit: e.unit,
            Rate: 0,
            Notes: '',
            BatchID: 0,
            BatchNo: 0,
            Batches: e.Batches ? JSON.stringify(e.Batches) : '[]'
          })
      }
    });

    let obj = [{
      XnTypeID: 10,
      XnNo: this.xnCode,
      XnNotes:'',
      InItems:  JSON.stringify(inItems),
      OutItems: JSON.stringify(outItems),
      InStoreID: this.frmStore.id,
      OutStoreID: this.frmStore.id,
      ExecUserID: 0,
      RelativeID: 0,
      OrderID: 0,
      PrdJobID: 0,
      DocDispatchID: 0,
      DocInvoiceID: 0,
      XnFields: JSON.stringify([]),
      RelAddr: '',
      DocIDs:0
    }];

    let myParams = [{
      myUserID: this.jarvisData[0].UserID,
      myToken: this.jarvisData[0].WebToken,
      forAgencyID: this.jarvisData[0].AgencyIDs,
      myAgencyIDs: this.jarvisData[0].AgencyIDs,
      ForERPAgencyID: this.MTbl[0].ERPAgencyID,
      myLastSyncDT: null,
      isWeb: true,
      actionType: 'setTransaction',
      moduleID: 5,
      data: JSON.stringify(obj)
    }];

    this.apiService.swalConfirm("Are you sure you want to enter this transaction?", () => {
      this.apiService.sendChange(myParams, this.successEntry.bind(this), this.failureResp.bind(this));
    });
  }

  //success production entry
  successEntry(res: any){
    if (res.error) {
      this.apiService.successAlert(res.message);
    }
    else {
      let altTxt = 'Transaction entered';
      this.apiService.successAlert(altTxt + '.');
      let responseData = JSON.parse(res.updatePackage);
      let xnID: number =  responseData.Table[0].XnID;
      var abcCfg_AgnCfg;
      abcCfg_AgnCfg = this.apiService.getCookie("Cfg_AgnCfg");
      if(abcCfg_AgnCfg) {
        abcCfg_AgnCfg = JSON.parse(abcCfg_AgnCfg);
           let latNos = JSON.parse(abcCfg_AgnCfg[0].LastXnNos);
      let tmpType = 'XN-' + 10;
      let index = 0;
      let tmpFilter = this.lastXNNos.filter((a: any) => a.XnTyp == tmpType);

      if(tmpFilter.length > 0) {
        latNos.forEach((element: any, index: number) => {
          if(element.XnTyp == tmpType) {
            element.LastNo = this.xnCode;
          }
        });
      }
      else {
        let tmpObj = {
          "XnTyp": tmpType,
          "LastNo": this.xnCode
        }

        latNos.push(tmpObj);
      }
      
      abcCfg_AgnCfg[0].LastXnNos = JSON.stringify(latNos);
      this.apiService.setCookie('Cfg_AgnCfg', JSON.stringify(abcCfg_AgnCfg));
      }
      this.printTranjection(xnID);
      if(this.isFromPrdJob == true){
        this.router.navigate(['ProductionList']);
      }
      else{
        this.router.navigate(['Stock']);
      }      
    }
  }

  //reset data
  resetData() {
    this.bomData  = [];
    this.items = [];
    this.isGenEdit = false;
    this.isShowBOM = false;

  }
  //failureResp - failure handler
  failureResp(res: any) {
    this.loadingPnl.hide();
    if (res.error) {
    }
    else {
      this.apiService.successAlert(res.message);
    }
  }

  // check issueQty and mtlQty when qty change
  prcisionCheck(obj: any) {
    obj.issueQty = this.commonService.PrecisionwiseValue(obj.issueQty + '', obj.Prcsn);
    obj.mtlQty = this.commonService.PrecisionwiseValue(obj.mtlQty + '', obj.prcsn);
  }

  //change qty
  getTransferQty(obj: any) {
    obj.issueQty =  Number(obj.issueQty).toFixed(obj.prcsn);//Number(this.items[i].issueQty);
    // for(let i = 0; i < this.items.length; i++) {
    //     if(this.items[i].issueQty){
    //       this.items[i].issueQty =  Number(this.items[i].issueQty).toFixed(this.items[i].prcsn);//Number(this.items[i].issueQty);
    //   }
    // }
  }

//change bom qty
  getUsedQty(obj: any) {
    obj.mtlQty =  Number(obj.mtlQty).toFixed(obj.prcsn);//Number(this.items[i].issueQty);
    // for(let i = 0; i < this.bomData.length; i++) {
    //   if(this.bomData[i].mtlQty){
    //     this.bomData[i].mtlQty = Number(this.bomData[i].mtlQty).toFixed(this.bomData[i].prcsn);
    //   }
    // }
  }

// Dilivery Challan Print data
  printTranjection(id: number){
    var XnID = this.commonService.encryptData(id);
    let AgencyID = this.commonService.encryptData(this.jarvisData[0].AgencyIDs);
    let target: string = "_blank";
    window.open('BasicPrdPrint?XnID=' + XnID + "&aid=" + AgencyID, target, 'Height= 800px, Width= 1000px, padding:10px, Top= 50px, Left= 100px, edge= Raised, center= Yes, help= No, resizable= No, status= No');
  }

  editGenItems() {
    this.isGenEdit = true;
    this.setPrdBatchCoockie();
  }

  setPrdBatchCoockie() {
    this.apiService.setCookie("selItems", "isFromPrd");
  }
  setMtlBatchCoockie() {
    this.apiService.setCookie("selItems", "isFromMtrl");
  }
  
}
